import { gql } from '@apollo/client';

import GraphQL from '../graphQL';

interface DeleteEmployeeTalkTemplateResult {
    deleteEmployeeTalkTemplate: boolean;
}

const DELETE_EMPLOYEE_TALK_TEMPLATE = gql`
  mutation DeleteEmployeeTalkTemplate($id: ID!) {
    deleteEmployeeTalkTemplate(id: $id)
  }
`;

export async function deleteEmployeeTalkTemplate(id: number): Promise<DeleteEmployeeTalkTemplateResult> {
    return GraphQL.mutate<DeleteEmployeeTalkTemplateResult>(DELETE_EMPLOYEE_TALK_TEMPLATE, { id });
}
